<template id="main-page">
  <v-ons-page >
    <v-ons-toolbar>
      <div class="center">Orçamento - {{this.nomeabrev}}</div>
      <div class="right">
      </div>
    </v-ons-toolbar>
    <v-ons-card>
      <div class="content">
      <p style="text-align: left; padding-left: 3%">    
        <small class="form-text font-weight-bold text-muted">Ordem de Compra</small>
        <br>
        <v-ons-input placeholder="Ordem de compra" style="width: 100%;" material input-id='ordCompr'
          v-model="ordCompr" />

      </p>
      <p style="text-align: left; padding-left: 3%">
        <small id="frete" class="form-text font-weight-bold text-muted">Local de Entrega</small>
        <br>
        <v-ons-select v-model="codEntrega" style="width: 100%;" input-id='codEntrega' @change="changeLocEntr($event)">
          <option v-for="item of locEntr" :key="item.codEntrega">{{item.codEntrega}}</option>
        </v-ons-select>
      </p>
      <p style="text-align: left; padding-left: 3%">
        {{endereco}}
        <br>
        {{cep}}
        {{bairro}}
        <br>
        {{cidade}},
        {{estado}}
      </p>
      <p style="text-align: left; padding-left: 3%">
        <small id="frete" class="form-text font-weight-bold text-muted">Tipo do frete</small>
        <br>
        <v-ons-select v-model="frete" style="width: 100%;" @change="changeFrete($event)" aria-describedby="frete">
          <option value="cif">CIF</option>
          <option value="fob">FOB</option>
        </v-ons-select>
      </p>
      <p style="text-align: left; padding-left: 3%" id="transp" v-if="actTransportador">
        <small class="form-text font-weight-bold text-muted">Transportador</small>
        <br>
        <vue-autosuggest v-model="nomeTransp" :suggestions="filteredOptionsTransp" @focus="focusMe"
          @click="clickHandlerTransp" @input="onInputChangeTransp" @selected="onSelectedTransp"
          :input-props="inputPropsTransp" :get-suggestion-value="getSuggestionValueTransp">
          <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
            <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.nome}} - {{suggestion.item.codTransp}}
            </div>
          </div>
        </vue-autosuggest>

      </p>
      <p style="text-align: left; padding-left: 3%">
        <small class="form-text font-weight-bold text-muted">Condição de Pagamento</small>
        <br>
        <vue-autosuggest v-model="codPagto" :suggestions="filteredOptions" @focus="focusMe" @click="clickHandler"
          @input="onInputChange" @selected="onSelected" :input-props="inputProps"
          :get-suggestion-value="getSuggestionValue">
          <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
            <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.codCondPag}} -
              {{suggestion.item.descricao}}</div>
          </div>
        </vue-autosuggest>
      </p>
      <p style="text-align: left; padding-left: 3%">
        {{descrPag}} <br> Parcelas: {{numParc}} <br> Prazo Médio: {{prazoMedio}}
      </p>
      <p style="text-align: left; padding-left: 3%">
        <small id="frete" class="form-text font-weight-bold text-muted">Comissão</small>
        <br>
        <select class="select-input select-input--material" style="width: 100%;" v-model="tpComis" aria-describedby="frete">
          <option value="c5">C5</option>
          <option value="c3">C3</option>
          <option value="c1">C1</option>
        </select>
      </p>
      <p style="text-align: left; padding-left: 3%">
        <small class="form-text font-weight-bold text-muted">Descontos</small>
        <br>
        {{descRota}} + {{descFrete}} + {{comissao1}} + {{comissao2}} + {{comissao3}} + {{especial}} + {{descFin}}
      </p>
      </div>
    </v-ons-card>
    <v-ons-card>
      <div class="title">
        Novo Item
      </div>
      <div class="content">
    <p style="text-align: left; padding-left: 3%">
              <vue-autosuggest
              v-model="buscaItem"
              :suggestions="filteredOptionsItem"    
              @focus="focusMeItem"
              @click="clickHandlerItem"
              @input="onInputChangeItem"
              @selected="onSelectedItem"
              :input-props="inputPropsItem"
              :get-suggestion-value="getSuggestionValueItem">
              <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
              <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.itCodigo}} - {{suggestion.item.descricao}}</div>
              </div>
              </vue-autosuggest>
      </p>
      <p style="text-align: left; padding-left: 3%">
        <small class="form-text font-weight-bold text-muted">Quantidade</small>
        <br>
        <v-ons-input placeholder="Quantidade" type="number" style="width: 100%;" @change="changeQtd($event)" material input-id='qtdItem'
          v-model="qtdItem" />

      </p>
      <p style="text-align: left; padding-left: 3%">
        {{descItem}} <br>
        Valor Unitário Tabela: {{valorItem | currency}} <br>
        Valor Total: {{valorItemTot | currency}} <br>
        Valor Liquído Unitário: {{valorLiqItem | currency}} <br>
        Valor Liquído Total: {{valorLiqTot | currency}} <br>
        </p>
        <p style="text-align: left; padding-left: 3%">
        <v-ons-button style="margin: 6px 0" v-if="!altItem && !detOrc" class="btn btn-success" v-on:click="addItem"><i class="fas fa-check"></i></v-ons-button>
        </p>
        </div>
    </v-ons-card> 
    <v-ons-card> 
    <div class="content">
      <v-ons-list>
      <v-ons-list-header>Itens</v-ons-list-header>
        <v-ons-list-item v-for="(item, index) in items" :key="item.cod">
            <div class="center"> 
                {{item.descricao}}
                <br>
                {{item.desconto}}
                <br>
                Quantidade: {{item.qtd}}
                <br>
                Valor: {{item.valLiq | currency}}
                <br>
                M3: {{item.m3}}
              </div>            
              <div class="left"> 
                <v-ons-button class="btn btn-danger" v-on:click="deleteItem(index)"><i class="fas fa-trash"></i></v-ons-button>
              </div>
        </v-ons-list-item>
        <hr>
         <v-ons-list-item style="font-size: 15px;text-align: left; padding-left: 3%"> Total de Itens: {{totalQtd}} <br> Valor: {{totalValLiq | currency}} <br> M³: {{totalm3}}
         </v-ons-list-item>
      </v-ons-list>
      </div>
      </v-ons-card> 

        <p style="text-align: left; padding-left: 3%">
       <button class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"  v-if="$route.params.tipo != 3" v-on:click="saveFile()">
        <i class="fas fa-save fa-sm text-white-50"></i> Salvar Orçamento </button> <br>
        </p>
  </v-ons-page>
</template>



<script>
  import { mapGetters } from 'vuex'
  import store from '../store/index.js'
  import local from '../services/sql.js'
  import erp from '../services/erp.js'


  export default {
    data() {
      return {
        dialogVisible: false,
        modalVisible: false,
        timeoutID: 0,
        spdVisible: true,
        spdOpen: false,
        shareItems: {
          'end': 'md-check',
        },
        spdVisible1: true,
        spdOpen1: false,
        shareItems1: {
          'add': 'md-plus',
        },
        buscaItem: '',
        enableFilterItem: false,
        descFin: 0,
        descFrete: 0,
        descRota: 0,
        comissao1: 0,
        comissao2: 0,
        comissao3: 0,
        especial: 0,
        adaptative: true,
        resizable: true,
        draggable: true,
        local: '',
        isActive: false,
        loadTabPre: false,
        infoLoad: false,
        sPedido: true,
        sItem: false,
        codEstabel: '',
        codEntrega: '',
        codPagto: '',
        codTransp: '',
        bairro: '',
        cidade: '',
        rota: '',
        cep: '',
        estado: '',
        endereco: '',
        nomeTransp: '',
        nomeAbTransp: '',
        dtEntrega: '',
        inscrestadual: '',
        natOperacao: '5101',
        locEntr: [],
        condPagto: [],
        transporte: [],
        tabItem: [],
        filterTabItem: [],
        tabelaPreco: [],
        matriz: '',
        filterItems: [],
        agenda: '',
        observnfe: '',
        actTransportador: false,
        detOrc: false,
        items: [],
        ordCompr: '',

        numParc: '',
        prazoMedio: '',
        descrPag: '',

        frete: '',
        codItem: '',
        descItem: '',
        qtdItem: '1',
        valorItem: '',
        valorItemTot: '',
        valorLiqItem: '',
        valorLiqTot: '',
        extra: 0,
        campanha: 0,
        erro: false,
        sucesso: false,
        tpFrete: '',

        //Pedido
        cgc: '',
        nomeabrev: '',
        rsocial: '',
        codemitente: '',
        tabPre: '',
        //FIM Pedido

        observacao: '',
        observnfe: '',

        //descontos
        desc1: 0,
        desc2: 0,
        desc3: 0,
        desc4: 0,
        desc5: 0,
        //fimdescontos
        tpComis: '',
        LprazoMedio: [],
        Lcomissao: [],
        varFrete: '',

        totalValLiq: '',
        totalValBru: '',
        totalQtd: '',
        itIndex: '',
        altItem: false,
        altOrc: '',
        listExtra: '',
        listCampanha: '',
        m3: '',
        totalm3: '',
        descontosDisp: '',
        query: '',
        filteredCondPagto: [],
        filteredTransp: [],
        filteredItem: [],

        selected: '',
        inputProps: {
          id: "autosuggest__input",
          placeholder: "Condição de Pagamento",
          type: Number,
        },
        inputPropsTransp: {
          id: "autosuggest__input",
          placeholder: "Transportador",
          type: Number,
        },
        inputPropsItem: {
          id: "autosuggest__input",
          placeholder: "Item: ",
          type: Number,
        },
      }
    },
    mounted() {

    },
    name: 'Users',
    computed: mapGetters([
      'isAdmin',
    ]),
    computed: {
      filteredOptions() {
        return [
          {
            data: this.filteredCondPagto.filter(option => {
              return option.codCondPag.toString().toLowerCase().indexOf(this.codPagto.toString().toLowerCase()) > -1 || option.descricao.toString().toLowerCase().indexOf(this.codPagto.toString().toLowerCase()) > -1;
            })
          }
        ];
      },
      filteredOptionsTransp() {
        return [
          {
            data: this.filteredTransp.filter(option => {
              return option.codTransp.toString().toLowerCase().indexOf(this.nomeTransp.toString().toLowerCase()) > -1 || option.nome.toString().toLowerCase().indexOf(this.nomeTransp.toString().toLowerCase()) > -1;
            })
          }
        ];
      },
      filteredOptionsItem() {
        return [
          {
            data: this.filteredItem.filter(option => {
              return option.descricao.toString().toLowerCase().indexOf(this.buscaItem.toString().toLowerCase()) > -1 || option.itCodigo.toString().toLowerCase().indexOf(this.buscaItem.toString().toLowerCase()) > -1;
            })
          }
        ];
      }
    },
    methods: {
      clickHandler(item) {
      },
      onSelected(item) {
        this.codPagto = item.item.codCondPag;
        this.numParc = item.item.numParcelas
        this.prazoMedio = item.item.qtdDiasPrazoMedio
        this.descrPag = item.item.descricao
        this.changeCondPag()
      },
      onInputChange(text) {
      },
      getSuggestionValue(suggestion) {
      },
      focusMe(e) {
      },
      clickHandlerTransp(item) {
      },
      onSelectedTransp(item) {
        this.codTransp = item.item.codTransp;
        this.nomeTransp = item.item.nome

      },
      onInputChangeTransp(text) {
      },
      getSuggestionValueTransp(suggestion) {
      },
      focusMeTransp(e) {
      },
      getSuggestionValueTransp(suggestion) {
      },
      clickHandlerItem(item) {
      },
      onSelectedItem(item) {
        this.setItem(item.item)
      },
      onInputChangeItem(text) {
      },
      getSuggestionValueItem(suggestion) {
      },
      focusMeItem(e) {
      },
      getSuggestionValueItem(suggestion) {
      },
      filterItem() {
        this.filterItems = this.tabItem.filter(k => {
          return k.itCodigo.toLowerCase().startsWith(this.codItem.toLowerCase()) || k.descricao.toLowerCase().match(this.codItem.toLowerCase())
        })
      },
      setItem(it) {
        this.buscaItem = it.descricao
        this.codItem = it.itCodigo
        this.descItem = it.descricao
        this.valorItem = it.precoVenda
        this.valorItemTot = it.precoVenda
        this.enableFilterItem = false
        this.filterItems = []

        this.changeQtd()
      },
      showPedido: function (event) {
        this.sPedido = true;
        this.sItem = false;
      },
      changeQtd() {
        this.valorItemTot = Number(((this.valorItem * this.qtdItem).toFixed(3)))

        var totalDesc = 0

        erp.cubagem(this.codItem).then(resposta => {
          this.m3 = Number(((resposta.data.cubagem * this.qtdItem) / 1000000).toFixed(2))
        })



        var valLiq = this.valorItemTot
        var valLiq1 = parseFloat(valLiq) - (parseFloat(this.valorItemTot) * (this.descFin / 100))
        var valLiq2 = parseFloat(valLiq1) - (parseFloat(valLiq1) * (this.descRota / 100))
        var valLiq3 = parseFloat(valLiq2) - (parseFloat(valLiq2) * (this.descFrete / 100))
        var valLiq4 = parseFloat(valLiq3) - (parseFloat(valLiq3) * (this.comissao1 / 100))
        var valLiq5 = parseFloat(valLiq4) - (parseFloat(valLiq4) * (this.comissao2 / 100))
        var valLiq6 = parseFloat(valLiq5) - (parseFloat(valLiq5) * (this.comissao3 / 100))
        var valLiq7 = parseFloat(valLiq6) - (parseFloat(valLiq6) * (this.especial / 100))
        var valLiq8 = parseFloat(valLiq7) - (parseFloat(valLiq7) * (this.extra / 100))

        this.valorLiqItem = Number(((parseFloat(valLiq8 / this.qtdItem)).toFixed(2)))
        this.valorLiqTot = Number(((parseFloat(valLiq8)).toFixed(2)))

      },
      showItem: function (event) {
        this.sPedido = false;
        this.sItem = true;

        this.changeItem()
      },
      deleteItem(it) {
        this.items.splice(it, 1);
        this.changeItem()
      },
      loadAddItem() {
        this.$modal.show('inclui-item');
      },
      addItem() {
        if (this.altItem == false) {
          var totalDesc = 0
          this.descontosDisp = ''

          this.totalValLiq += Number(((parseFloat(this.valorLiqTot)).toFixed(2)))
          this.totalValBru += Number(((parseFloat(this.valorItemTot)).toFixed(2)))
          this.totalQtd += parseFloat(this.qtdItem)
          this.totalm3 += Number(((parseFloat(this.m3)).toFixed(2)))

          console.log(this.extra)

          this.buscaItem = ''

          if (this.descRota != 0) {
            this.descontosDisp += this.descRota
          }
          if (this.descFrete != 0) {
            this.descontosDisp += "+" + this.descFrete
          }
          if (this.comissao1 != 0) {
            this.descontosDisp += "+" + this.comissao1
          }
          if (this.comissao2 != 0) {
            this.descontosDisp += "+" + this.comissao2
          }
          if (this.comissao3 != 0) {
            this.descontosDisp += "+" + this.comissao3
          }
          if (this.descFin != 0) {
            this.descontosDisp += "+" + this.descFin
          }
          if (this.especial != 0) {
            this.descontosDisp += "+" + this.especial
          }
          if (this.extra != 0) {
            this.descontosDisp += "+" + this.extra
          }
          if (this.campanha != 0) {
            this.descontosDisp += "+" + this.campanha
          }


          this.items.push({
            cod: this.codItem,
            qtd: this.qtdItem,
            valorUnit: this.valorItem,
            valor: this.valorItemTot,
            descricao: this.descItem,
            extra: this.extra,
            campanha: this.campanha,
            valLiqUnit: this.valorLiqItem,
            valLiq: this.valorLiqTot,
            m3: this.m3,
            desconto: this.descontosDisp
          })

          this.closeModal()
          this.changeItem()
        }
      },
      changeItem() {

        this.totalValLiq = 0
        this.totalValBru = 0
        this.totalQtd = 0
        this.totalm3 = 0
        this.descontosDisp = ''

        console.log(this.extra)

        if (this.descRota != 0) {
          this.descontosDisp += this.descRota
        }
        if (this.descFrete != 0) {
          this.descontosDisp += "+" + this.descFrete
        }
        if (this.comissao1 != 0) {
          this.descontosDisp += "+" + this.comissao1
        }
        if (this.comissao2 != 0) {
          this.descontosDisp += "+" + this.comissao2
        }
        if (this.comissao3 != 0) {
          this.descontosDisp += "+" + this.comissao3
        }
        if (this.especial != 0) {
          this.descontosDisp += "+" + this.especial
        }
        if (this.descFin != 0) {
          this.descontosDisp += "+" + this.descFin
        }
        if (this.extra != 0) {
          this.descontosDisp += "+" + this.extra
        }
        if (this.campanha != 0) {
          this.descontosDisp += "+" + this.campanha
        }


        for (var i = 0; i < this.items.length; i++) {
          var valLiq = this.items[i].valor

          this.totalm3 += Number(((parseFloat(this.items[i].m3)).toFixed(2)))

          var valLiq1 = parseFloat(valLiq) - (parseFloat(valLiq) * (this.descFin / 100))
          var valLiq2 = parseFloat(valLiq1) - (parseFloat(valLiq1) * (this.descRota / 100))
          var valLiq3 = parseFloat(valLiq2) - (parseFloat(valLiq2) * (this.descFrete / 100))
          var valLiq4 = parseFloat(valLiq3) - (parseFloat(valLiq3) * (this.comissao1 / 100))
          var valLiq5 = parseFloat(valLiq4) - (parseFloat(valLiq4) * (this.comissao2 / 100))
          var valLiq6 = parseFloat(valLiq5) - (parseFloat(valLiq5) * (this.comissao3 / 100))
          var valLiq7 = parseFloat(valLiq6) - (parseFloat(valLiq6) * (this.especial / 100))
          var valLiq8 = parseFloat(valLiq7) - (parseFloat(valLiq7) * (this.items[i].extra / 100))

          this.items[i].valLiq = Number(((parseFloat(valLiq8)).toFixed(2)))
          this.items[i].valLiqUnit = Number(((parseFloat(valLiq8 / this.items[i].qtd)).toFixed(2)))
          this.items[i].desconto = this.descontosDisp

          this.totalValLiq += Number(((parseFloat(valLiq8)).toFixed(2)))
          this.totalValBru += Number(((parseFloat(valLiq)).toFixed(2)))
          this.totalQtd += parseFloat(this.items[i].qtd)
        }
      },
      alteraItem(it) {
        this.itIndex = it
        this.altItem = true;
        this.codItem = this.items[it].cod
        this.qtdItem = this.items[it].qtd
        this.extra = this.items[it].extra
        this.campanha = this.items[it].campanha
        this.valorItem = this.items[it].valorUnit
        this.valorItemTot = this.items[it].valor
        this.valorLiqItem = this.items[it].valLiqUnit
        this.valorLiqTot = this.items[it].valLiq
        this.m3 = this.items[it].m3

      },
      updateItem() {
        this.items[this.itIndex].cod = this.codItem
        this.items[this.itIndex].qtd = this.qtdItem
        this.items[this.itIndex].extra = this.extra
        this.items[this.itIndex].campanha = this.campanha
        this.items[this.itIndex].valorUnit = this.valorItem
        this.items[this.itIndex].valor = this.valorItemTot
        this.items[this.itIndex].valLiqUnit = this.valorLiqItem
        this.items[this.itIndex].valLiq = this.valorLiqTot
        this.items[this.itIndex].m3 = this.m3
        this.closeModal()
        this.changeItem()
      },
      changeDesc() {
        totalDesc = this.descFin + "+" + this.descFrete + "+" +
          this.descRota + "+" + this.comissao1 + "+" + this.comissao2 + "+" +
          this.comissao3 + "+" + this.especial + "+" + this.extra
      },
      closeModal() {
        this.altItem = false
        this.codItem = ''
        this.valorItem = 0
        this.qtdItem = 0
        this.valorItemTot = 0
        this.descItem = 0
        this.descTot = 0
        this.desc1 = 0
        this.desc2 = 0
        this.desc3 = 0
        this.desc4 = 0
        this.desc5 = 0
        this.extra = 0
        this.campanha = 0
        this.valorItem = 0
        this.valorLiqItem = 0
        this.valorLiqTot = 0
        this.m3 = 0
      },
      exportToPdf() {
        console.log('teste')
        this.emailOrcamentoComercial(this.nrpedido)
      },
      changeLocEntr(event) {
        this.locEntr.forEach(element => {
          if (element.codEntrega == event.target.value) {
            console.log(element.codRota)
            this.cidade = element.cidade
            this.bairro = element.bairro
            this.cep = element.cep
            this.rota = element.codRota
            this.estado = element.estado
            this.endereco = element.endereco
          }
        });
        local.Prota({ codRota: this.rota }).then(resposta => {
          this.descRota = resposta.data[0].desc_rota
          this.varFrete = resposta.data[0].desc_frete
        })
      },
      getExtra() {
        return this.listExtra.filter((result) => {
          return
          result['tabpre'].toLowerCase().match(this.tabPre.toLowerCase()) ||
            (result['tabpre'].toLowerCase().match(this.tabPre.toLowerCase()) || result['matriz'].toLowerCase().match(this.matriz.toLowerCase())) ||
            (result['tabpre'].toLowerCase().match(this.tabPre.toLowerCase()) || result['matriz'].toLowerCase().match(this.matriz.toLowerCase()) || result['cgc_filial'].toLowerCase().match(this.matriz.toLowerCase()))
        })
      },
      changeFrete(event) {
        this.tpFrete = event.target.value
        if (event.target.value == "cif") {
          this.actTransportador = false
          this.codTransp = '',
            this.nomeTransp = '',
            this.descFrete = 0
        }
        else {
          this.actTransportador = true
          this.descFrete = this.varFrete
        }
      },
      changeTabPre(event) {
        erp.precoItem(this.tabPre).then(resposta => {
          this.tabItem = resposta.data
        })
      },
      changeCondPag() {
        let arrayPrazo = []
        /*this.condPagto.forEach(element => {
          if (element.codCondPag == event.target.value) {
            this.numParc = element.numParcelas
            this.prazoMedio = element.qtdDiasPrazoMedio
            this.descrPag = element.descricao
          }
        });*/

        arrayPrazo = this.LprazoMedio.filter((k) => {
          return k.dias == this.prazoMedio
        })

        if (arrayPrazo.length > 0) {
          this.descFin = arrayPrazo['0'].perc
        }
        else {
          this.descFin = 0
        }
      },
      fechaMsg() {
        this.erro = false
        this.sucesso = false
      },
      itemModal() {
        this.modalVisible = true;
        clearTimeout(this.timeoutID)
      },
      async saveFile() {

        var valTot = 0

        this.items.forEach(a => {
          valTot += Number(a.valLiq)
        })


        if (valTot < this.local[0].valMin) {
          var msg = 'Valor do pedido é inferior ao mínimo. \r\n Valor Mínimo: R$' + this.local[0].valMin.toString() + '. \r\n Valor atual: R$' + valTot.toString()
          this.$ons.notification.toast(msg, { timeout: 8000 });
        }

        else if ((valTot / this.numParc) < this.local[0].parcMin) {
          var msg = 'Valor da parcela é inferior ao mínimo de R$ 500,00 por parcela'
          this.$ons.notification.toast(msg, { timeout: 8000 });
        }
        else {

          if (this.altOrc == false) {

            var d = new Date();
            var h = d.getHours();
            var m = d.getMinutes();
            var s = d.getSeconds();
            var dd = d.getDate();
            var mm = d.getMonth() + 1;
            var yyyy = d.getFullYear();

            var dataImplant = dt(d)
            console.log(this.codEntrega)
            var nrpedido = h.toString() + m.toString() + s.toString() + dd.toString() + mm.toString() + yyyy.toString().substring(0, 2)

            this.status = 1

            this.items.forEach(k => {
              if (k.extra > 0) {
                this.status = 2
              }
              local.itOrcamento({
                codigo: k.cod,
                valor: k.valor,
                extra: k.extra,
                campanha: k.campanha,
                nrpedido: nrpedido,
                qtd: k.qtd,
                cgc: this.cgc,
                m3: k.m3
              }).then(resposta => {
                console.log(resposta)
              })
            })

            local.orcamento({
              cgc: this.cgc, nrpedido: nrpedido, repres: this.$store.getters.getCodrep, status: this.status,
              tabPre: this.tabPre, natOperacao: this.natOperacao, codPagto: this.codPagto, frete: this.tpFrete, transporte: this.codTransp,
              agenda: this.agenda, observacao: this.observacao, observnfe: this.observnfe, dataImplant: dataImplant, codEntrega: this.codEntrega,
              descFin: this.descFin,
              descFrete: this.descFrete,
              descRota: this.descRota,
              comissao1: this.comissao1,
              comissao2: this.comissao2,
              comissao3: this.comissao3,
              especial: this.especial,
              tpComis: this.tpComis,
              oc: this.ordCompr,
            }).then(resposta => {
            })

          this.$ons.notification.toast('Orçamento salvo com sucesso', { timeout: 8000 });

            this.$router.push("/consultaOrcamento")

          }
          if (this.altOrc == true) {

            this.changeItem()

            var d = new Date();
            var h = d.getHours();
            var m = d.getMinutes();
            var s = d.getSeconds();
            var dd = d.getDate();
            var mm = d.getMonth() + 1;
            var yyyy = d.getFullYear();

            var dataImplant = dt(d)

            local.delItOrcamento({
              nrpedido: this.nrpedido
            })

            local.upOrcamento({
              cgc: this.cgc, nrpedido: this.nrpedido, repres: this.$store.getters.getCodrep, status: 1,
              tabPre: this.tabPre, natOperacao: this.natOperacao, codPagto: this.codPagto, frete: this.tpFrete, transporte: this.codTransp,
              agenda: this.agenda, observacao: this.observacao, observnfe: this.observnfe, dataImplant: dataImplant, codEntrega: this.codEntrega,
              descFin: this.descFin,
              descFrete: this.descFrete,
              descRota: this.descRota,
              comissao1: this.comissao1,
              comissao2: this.comissao2,
              comissao3: this.comissao3,
              especial: this.especial,
              tpComis: this.tpComis,
              oc: this.ordCompr,
            }).then(resposta => {
              console.log(resposta)
            })

            this.items.forEach(k => {
              if (k.extra > 0) {
                this.status = 2
              }
              local.itOrcamento({
                codigo: k.cod,
                valor: k.valor,
                extra: k.extra,
                campanha: k.campanha,
                nrpedido: this.nrpedido,
                qtd: k.qtd,
                cgc: this.cgc,
                m3: k.m3
              }).then(resposta => {
                console.log(resposta)
              })
            })

          }
          this.$router.push("/consultaOrcamento")
        }
      }
    },
    watch: {
    tpComis: async function (val) {
      await local.comissao().then(k => {
          if (val == "c5") {
            this.comissao1 = k.data['0'].c5
            this.comissao2 = 0
            this.comissao3 = 0
          }
          if (val == "c3") {
            this.comissao1 = k.data['0'].c5
            this.comissao2 = k.data['0'].c3
            this.comissao3 = 0
          }
          if (val == "c1") {
            this.comissao1 = k.data['0'].c5
            this.comissao2 = k.data['0'].c3
            this.comissao3 = k.data['0'].c1
          }
        })
        this.changeItem()
    },
    codPagto: function (val) {
      this.changeItem()
    },
    nomeTransp: function (val) {
      this.changeItem()
    },
    frete: function (val) {
      this.changeItem()
    },
    },
    created() {

      local.config().then(resposta => {
        this.local = resposta.data
      })

      if (this.$route.params.tipo == '1') {
        this.altOrc = false

      erp.detalhe(this.$route.params.id).then(resposta => {
        console.log(resposta.data)
        this.codemitente = resposta.data['cod-emitente']
        this.nomeabrev = resposta.data['nome-abrev']
        this.rsocial = resposta.data['nome-emit']
        this.cgc = resposta.data['cgc']
        this.matriz = resposta.data['nome-matriz']
        this.inscrestadual = resposta.data['ins-estadual']
        this.tabPre = resposta.data['nr-tabpre']
        this.codEstabel = '101'
        //this.codPagto = resposta.data['cod-cond-pag']
        erp.precoItem(this.tabPre).then(resposta => {
          this.tabItem = resposta.data
          this.tabItem.forEach(a => {
            this.filteredItem.push({
              itCodigo: a.itCodigo,
              descricao: a.descricao,
              precoVenda: a.precoVenda
            })
          })
        })
        erp.endEntrega(this.nomeabrev).then(resposta => {
          if (Array.isArray(resposta.data)) {
            this.locEntr = resposta.data
          }
          else {
            this.locEntr = [resposta.data]
          }
        })
      }),
        erp.tabelapreco().then(resposta => {
          this.tabelaPreco = resposta.data
        })
      local.prazoMedio().then(resposta => {
        this.LprazoMedio = resposta.data
      })
      erp.condPagto().then(cp => {
        this.condPagto = cp.data
        this.condPagto.forEach(a => {
          this.filteredCondPagto.push(
            {
              codCondPag: a.codCondPag,
              descricao: a.descricao,
              numParcelas: a.numParcelas,
              qtdDiasPrazoMedio: a.qtdDiasPrazoMedio
            }
          )
        })
      }),

        erp.transporte().then(tr => {
          this.transporte = tr.data
          this.transporte.forEach(a => {
            this.filteredTransp.push({
              codTransp: a['cod-transp'],
              nome: a['nome']
            })
          })
        })
      local.especial().then(k => {
        this.especial = k.data[0].perc
      }),
        local.campanha().then(resposta => {
          this.listCampanha = resposta.data
        }),
        local.extra().then(resposta => {
          this.listExtra = resposta.data
        })
      }
      if (this.$route.params.tipo == '2' || this.$route.params.tipo == '3') {
        this.altOrc = true
        this.nrpedido = this.$route.params.id

        local.UniqOrcamento({ nrpedido: this.nrpedido }).then(resposta => {
          this.natOperacao = resposta.data[0].natOperacao
          this.agenda = resposta.data[0].agenda
          this.tabPre = resposta.data[0].tabPre
          this.observacao = resposta.data[0].observacao
          this.observnfe = resposta.data[0].observnfe
          this.cgc = resposta.data[0].cgc
          this.codEntrega = resposta.data[0].codEntrega
          this.codPagto = resposta.data[0].codPagto
          this.codTransp = resposta.data[0].transporte
          this.frete = resposta.data[0].frete
          this.status = resposta.data[0].status
          this.descFin = resposta.data[0].descFin
          this.descRota = resposta.data[0].descRota
          this.descFrete = resposta.data[0].descFrete
          this.comissao1 = resposta.data[0].comissao1
          this.comissao2 = resposta.data[0].comissao2
          this.comissao3 = resposta.data[0].comissao3
          this.especial = resposta.data[0].especial
          this.tpComis = resposta.data[0].tpComis
          this.ordCompr = resposta.data[0].oc
		  this.tabPre   = resposta.data[0].tabPre
		  if (resposta.data[0].frete == "fob") {
			this.actTransportador = true
		  }
          erp.detalhe(resposta.data[0].cgc).then(a => {
            this.rsocial = a.data['nome-emit']
            this.codemitente = a.data['cod-emitente']
            this.nomeabrev = a.data['nome-abrev']
            this.matriz = a.data['nome-matriz']
            erp.endEntrega(a.data['nome-abrev']).then(b => {
			if (Array.isArray(b.data)) {
            this.locEntr = b.data
			 this.locEntr.forEach(element => {			 
                if (element.codEntrega == b.data[0].codEntrega) {
                  this.cidade = element.cidade
                  this.bairro = element.bairro
                  this.cep = element.cep
                  this.rota = element.codRota
                  this.estado = element.estado
                  this.endereco = element.endereco
                }
              })
            }
            else {
            this.locEntr = [b.data]
			this.locEntr.forEach(element => {
			
                if (element.codEntrega == resposta.data[0].codEntrega) {
                  this.cidade = element.cidade
                  this.bairro = element.bairro
                  this.cep = element.cep
                  this.rota = element.codRota
                  this.estado = element.estado
                  this.endereco = element.endereco
                }
              })
            }
	
	       erp.precoItem(this.tabPre).then(c => {
            this.tabItem = c.data
            this.tabItem.forEach(a => {
              this.filteredItem.push({
                itCodigo: a.itCodigo,
                descricao: a.descricao,
                precoVenda: a.precoVenda
              })
            })
          })

            })
			
        erp.condPagto().then(cp => {
          this.condPagto = cp.data 
          this.condPagto.forEach(a => {
		  if (a.codCondPag == resposta.data[0].codPagto) {
			this.descrPag     = a.descricao
			this.numParc      = a.numParcelas
			this.prazoMedio   = a.qtdDiasPrazoMedio
		  }
          this.filteredCondPagto.push(
          {
            codCondPag: a.codCondPag,
            descricao: a.descricao,
            numParcelas: a.numParcelas,
            qtdDiasPrazoMedio: a.qtdDiasPrazoMedio
          }
          )
        })  
        }),
          erp.transporte().then(tr => {
            this.transporte = tr.data
            this.transporte.forEach(a => {
			if (a['cod-transp'] == this.codTransp) {
				this.nomeTransp = a['nome']
			}
            this.filteredTransp.push({
              codTransp: a['cod-transp'],
              nome: a['nome']
            })
            })
          })
          })
        })
        local.ItemUniqOrcamento({ nrpedido: this.nrpedido }).then(resposta => {
          this.item = resposta.data

          this.item.forEach(k => {
            erp.itemInfo(k.codigo).then(b => {
              this.items.push({
                cod: k.codigo,
                descricao: b.data.descItem,
                qtd: k.qtd,
                valorUnit: k.valor / k.qtd,
                valor: k.valor,
                extra: k.extra,
                campanha: k.campanha,
                m3: k.m3
              })
            })
          })
        })
      } // Fim alteração
    } // Fim novo orçamento
  }

  function pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  function dt(d) {
    var dd = d.getDate();
    var mm = d.getMonth() + 1;
    var yyyy = d.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dd + mm + yyyy
  }

</script>


<style>
  #autosuggest__input {
    outline: none;
    position: relative;
    display: block;
    border: 1px solid #616161;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  #autosuggest__input.autosuggest__input-open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  .autosuggest__results {
    margin: 0;
    position: absolute;
    z-index: 10000001;
    font-size:"12px";
    width: 100%;
    border: 1px solid #e0e0e0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: white;
    padding: 0px;
    overflow: scroll;
    max-height: 200px;
  }

  .autosuggest__results ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .autosuggest__results .autosuggest__results_item {
    cursor: pointer;
    padding: 15px;
  }

  #autosuggest ul:nth-child(1)>.autosuggest__results_title {
    border-top: none;
  }

  .autosuggest__results .autosuggest__results_title {
    color: gray;
    font-size: 6px;
    margin-left: 0;
    padding: 15px 13px 5px;
    border-top: 1px solid lightgray;
  }

  .autosuggest__results .autosuggest__results_item:active,
  .autosuggest__results .autosuggest__results_item:hover,
  .autosuggest__results .autosuggest__results_item:focus,
  .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
    background-color: #ddd;
  }

  .autosuggest-container {
    display: flex;
    justify-content: center;
    width: 280px;
  }

  #autosuggest {
    width: 100%;
    display: block;
  }

  .autosuggest__results-item--highlighted {
    background-color: rgba(51, 217, 178, 0.2);
  }
</style>